import React from "react";
import { Product } from "shared/api/middleware-api-client";
import ProfielProductItem from "./ProfielProductItem";
import CheckoutProductControls from "features/checkout/product-controls";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import ProductItemCheckout from "entities/product-item-checkout";
import ZakelijkDoorProductItem from "./ZakelijkDoorProductItem";

export const ZakelijkProductItem = ({
  product,
  index,
}: {
  product: Product;
  index: number;
}) => {
  //Is profiel product
  const isProfielProduct = zakelijkProfielCodes.includes(product.doorType.code);

  // Profiel product
  if (isProfielProduct) {
    return (
      <ProfielProductItem
        product={product}
        controls={
          <CheckoutProductControls hideEditButton={true} index={index} />
        }
      />
    );
  }
  return (
    <ZakelijkDoorProductItem
      product={product}
      controls={<CheckoutProductControls index={index} />}
    />
  );
};
